export function truncateString(string, maxLength) {
    if (string.length > maxLength) {
        return string.slice(0, maxLength) + '…';
    }
    return string;
}

export function lowercaseFirstLetter(string) {
    return string.charAt(0).toLowerCase() + string.slice(1);
}